import { render, staticRenderFns } from "./CompilationAddThingsPage.vue?vue&type=template&id=f07104d8&scoped=true&"
import script from "./CompilationAddThingsPage.vue?vue&type=script&lang=ts&"
export * from "./CompilationAddThingsPage.vue?vue&type=script&lang=ts&"
import style0 from "./CompilationAddThingsPage.vue?vue&type=style&index=0&id=f07104d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f07104d8",
  null
  
)

export default component.exports